<template>
  <div class="">
    <div class="df df-center">
      <a-date-picker
        v-model:value="cascadeDate"
        placeholder="请选择时间"
        style="width: 160px"
      />
    </div>
    <!-- 生产任务表 -->
    <tasks-vue
      :type="props.type"
      :editAuthority="props.deleteAuthority['edit_components_tasks']"
      :produceOrTpc="produceOrTpc"
    ></tasks-vue>

    <!-- 质检信息 -->
    <quality-inspection-vue
      :type="props.type"
      :produceOrTpc="produceOrTpc"
      :closedLoopAuthority="props.deleteAuthority['/closedLoopAuthority']"
    ></quality-inspection-vue>
    <!-- 后工序发生本工序问题 -->
    <core-problem :type="props.type" :produceOrTpc="produceOrTpc"> </core-problem>

    <!-- 备份文件 -->
    <backup-file v-if="props.type === 'assembleDebug'"></backup-file>

    <!-- 异常问题统计 -->
    <abnormal-problem-vue
      :type="props.type"
      :produceOrTpc="produceOrTpc"
      :deleteAuthority="
        props.deleteAuthority['deleteAbnormalProblemHandle']
      "
    ></abnormal-problem-vue>
    <!-- 作业指导书及其记录表反馈 -->
    <sop
      :type="props.type"
      :produceOrTpc="produceOrTpc"
      :deleteAuthority="props.deleteAuthority['deleteWIRecord']"
    ></sop>
    <!-- 工位检查 -->
    <station-check
      :type="props.type"
      :produceOrTpc="produceOrTpc"
      :deleteAuthority="props.deleteAuthority['deleteStationCheck']"
    ></station-check>
    <!-- 工艺变更 -->
    <process-update
      :type="props.type"
      :produceOrTpc="produceOrTpc"
      :deleteAuthority="props.deleteAuthority['deleteProcessChange']"
    ></process-update>
    <!-- 质量抽查 -->
    <quality-spot-check
      :type="props.type"
      :produceOrTpc="produceOrTpc"
      :deleteAuthority="
        props.deleteAuthority['deleteQualitySpotCheck']
      "
    ></quality-spot-check>
    <!-- 质量抽查 -->
    <update-capacity-spot-check
      :type="props.type"
      :produceOrTpc="produceOrTpc"
      :deleteAuthority="
        props.deleteAuthority['deleteCapacitySpotCheck']
      "
    ></update-capacity-spot-check>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, provide, inject } from "vue";
import moment from "moment";
import { timeStampToTime } from "@/utils/index";
import tasksVue from "@/views/productDaily/components/product/organizingTasks/threePieced.vue";
import qualityInspectionVue from "@/views/productDaily/components/product/components/qualityInspection/index.vue";
import abnormalProblemVue from "@/views/productDaily/components/product/components/abnormalProblem/index.vue";
import materialShortage from "@/views/productDaily/components/product/components/materialShortage/index.vue";
import sop from "@/views/productDaily/components/product/components/sop/index.vue";
import stationCheck from "@/views/productDaily/components/product/components/stationCheck/index.vue";
import processUpdate from "@/views/productDaily/components/product/components/processUpdate/index.vue";
import qualitySpotCheck from "@/views/productDaily/components/product/components/qualitySpotCheck/index.vue";
import updateCapacitySpotCheck from "@/views/productDaily/components/product/components/updateCapacitySpotCheck/index.vue";
import coreProblem from "@/views/productDaily/components/product/components/coreProblem/index.vue";
import backupFile from "@/views/productDaily/components/product/components/backupFile/index.vue";

export default defineComponent({
  props: {
    deleteAuthority: Object,
    type: String,
  },
  components: {
    sop,
    tasksVue,
    backupFile,
    qualityInspectionVue,
    abnormalProblemVue,
    materialShortage,
    stationCheck,
    processUpdate,
    qualitySpotCheck,
    coreProblem,
    updateCapacitySpotCheck,
  },
  setup(props) {
    const cascadeDate = ref(
      moment(timeStampToTime("", "upload"), "YYYY-MM-DD")
    );
    provide("cascadeDate", cascadeDate);

    const produceOrTpc = inject('produceOrTpc', null);

    return {
      cascadeDate,
      produceOrTpc,
      props,
    };
  },
});
</script>

<style lang="less" scoped>
</style>
